import Vue from 'vue';
import { analyticsServiceFactory, Options } from '@uikit/analytics-manager';

export function AnalyticsPlugin(app: typeof Vue): void {
  app.prototype.$analytics = analyticsServiceFactory.create();
  const prefix = `${process.env.VUE_APP_PUBLIC_PATH_PREFIX}`;
  const options: Options = {
    title: `${process.env.VUE_APP_NAME}`,
    location: `${window.location.origin}${prefix}${process.env.VUE_APP_NAME}`
  };
  app.prototype.$analytics.initialize(options);
}
